<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="adc01">
<h2 class="adCardHead"><span class="bold">Other two-in-one Westerns from Cameron Judd</span></h2>
<p class="adCardText"><em class="italic">Devil Wire</em></p>
<p class="adCardText"><em class="italic">Brazos</em></p>
<p class="adCardText1"><em class="italic">The Quest of Brady Kenton</em></p>
<p class="adCardText"><em class="italic">Kenton’s Challenge</em></p>
<p class="adCardText1"><em class="italic">Timber Creek</em></p>
<p class="adCardText"><em class="italic">Renegade Lawmen</em></p>
<p class="adCardText1"><em class="italic">Snow Sky</em></p>
<p class="adCardText"><em class="italic">Corrigan</em></p>
<p class="adCardText1"><span class="bold">Available from St. Martin's Paperbacks</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_adc01.vue?74e11bce